import React from 'react';
import { find, sumBy } from 'lodash';

import { DonutChart } from '@magoosh/lib/charts';
import {
  minutesFormattedasHoursAndMinutesString,
  minutesFormattedAsShortString
} from 'utilities/time';

import StatisticData from '@test_prep/app/pages/analytics/components/statistic_data';
import { isIELTSExamName } from '@test_prep/app/pages/analytics/exam_name_utils';
import predeterminedColors from '@test_prep/app/pages/analytics/predetermined_colors';

import loadingData from './loading_data';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  examName: string;
  filters: any;
}

const StudyTimeChart: React.FC<Props> = (props) => {
  const loadingPlaceholder = (
    <DonutChart
      chartProps={{ animate: false }}
      data={loadingData(props.examName, props.filters.sections)}
      legendPosition="bottom"
      size={150}
    />
  );

  const formatLegendGroupName = (label) => {
    let potentialGroupNames = [];

    if (props.examName === 'GMAT') {
      potentialGroupNames = ['Quantitative Reasoning', 'Verbal Reasoning', 'Data Insights']
    } else if (props.examName === 'GRE') {
      potentialGroupNames = ['Math', 'Verbal', 'Writing']
    } else if (props.examName === 'TOEFL' || isIELTSExamName(props.examName)) {
      potentialGroupNames = ['Reading', 'Listening', 'Writing', 'Speaking']
    }

    const groupName = find(potentialGroupNames, (groupName) => (
      label.startsWith(groupName)
    ));

    return groupName || label;
  };

  const formatStatisticData = (statisticData) => {
    return statisticData.map((datum) => {
      const formattedData = {
        label: datum.name,
        value: datum.value
      } as any;
      const predeterminedColor = predeterminedColors(datum.name, props.examName);

      if (predeterminedColor) {
        formattedData.color = predeterminedColor;
      }

      return formattedData;
    });
  };

  const formatValue = (value) => {
    return minutesFormattedasHoursAndMinutesString(value);
  };

  if (!props.filters) {
    return loadingPlaceholder;
  } else {
    return (
      <StatisticData
        filters={props.filters}
        formatDataFn={formatStatisticData}
        name="study_time"
      >
        <StatisticData.Loading>
          {loadingPlaceholder}
        </StatisticData.Loading>

        {/* @ts-ignore */}
        <DonutChart
          chartProps={{ animate: false }}
          interior={(data) => (
            <strong>
              <span style={{ color: colors.dataDarkPurple, fontSize: 150 * 0.25 }}>
                {minutesFormattedAsShortString(sumBy(data, 'value'))}
              </span>
            </strong>
          )}
          formatValueFn={formatValue}
          legendGroupNameFn={formatLegendGroupName}
          legendPosition="bottom"
          size={150}
        />
      </StatisticData>
    );
  }
};

export default StudyTimeChart;
